export const BUTTON_LABEL = {
  ADD_TO_TRANSCRIPT: 'Add to Transcript',
  VIEW_TRANSCRIPT: 'View Transcript',
  RETRY_FOR_CREDIT: 'Retry for Credit',
  CREDIT_PENDING: 'Credit Pending',
  NEEDS_ASURITE_ACTIVATION: 'Activate ASURITE',
  CREDIT_ON_HOLD: 'Credit on hold',
  CREDIT_REJECTED: 'Credit rejected',
  UPGRADE: 'Upgrade',
  // Casing must match makeHttpRequest BUTTON_ACTIONS — the card compares raw labels.
  VERIFY_IDENTITY: 'Verify Identity',
  ACCESS_COURSE: 'Access Course'
};

export const JOURNEY_CODES = {
  'ConnectorService.loadPartnerDetails_/api/partners': 'Fetch Partners Info',
  'ConnectorService.getCourseList_/api/degree-courses': 'Fetch Partners Courses',
  'ConnectorService.getPathwayDegreeCourseList_/api/degree-courses/pathways': 'Fetch Pathway Degree Courses',
  'ConnectorService.getDashboardPageData_/api/enrollments': 'Fetch Learners Enrollments',
  'ConnectorService.getPathwayData_/api/degree-courses/pathways': 'Fetch Pathways Info',
  'ConnectorService.verifyLearnerDetails_/api/learner/verify': 'Verify Learners Info',
  'ConnectorService.getLearnerDetails_/api/learner': 'Fetch Learners Info',
  'ConnectorService.validateSignup_/api/learner': 'Learners Registration',
  'ConnectorService.unEnrollAtCanvas_/api/enrollment/canvas': 'Canvas course unenrollment',
  'ConnectorService.postIDVerificationImages_/api/learner/id-verify': 'Posting ID Verification Images',
  'ConnectorService.initiateIdVerification_/v2/api/learner/id-verify/initiate': 'Initiate magic-link IDV',
  'ConnectorService.confirmIdVerification_/v2/api/learner/id-verify/confirm': 'Confirm magic-link IDV',
  'ConnectorService.enrollAtCanvas_/api/enrollment/canvas': 'Learners Canvas Registration',
  'ConnectorService.enrollCourseInCanvas_/api/enrollment/canvas': 'Canvas Course Enrollment',
  'ConnectorService.upgradeCanvasCourse_/api/enrollment/canvas': 'Canvas Course Upgrade',
  'ConnectorService.patchEnrollmentsData_/api/enrollments': 'Update Enrollment Info',
  'ConnectorService.closeConfettiDialogMessage_/api/learner': 'Update Confetti Info',
  'ConnectorService.patchLearnersInfo_/api/learner': 'Update Learners Info',
  'ConnectorService.createCourseConnectionInSalesforce_/api/enrollments': 'Enroll In Selected Courses',
  'ConnectorService.unenrollCourse_/api/enrollments': 'Unenroll In Selected Courses',
  'ConnectorService.updatePathwayCompletedDate_/api/learner': 'Update Pathways Completed Date',
  'ConnectorService.updatePathwayConnection_/api/learner': 'Update Pathway Connection',
  'ConnectorService.postTransaction_/api/transaction': 'Create Transaction for Upgrade/Credit',
  'ConnectorService.postCreditRequest_/api/transaction/credit/request': 'Credit Request',
  'ConnectorService.gradeChange_/api/enrollments/grade': 'Fetch Grade Change',
  'ConnectorService.saveOpenEdxId_/api/learner': 'Update Learners OpenEdxId',
  'ConnectorService.updateIDVerify_/api/learner': 'Update Learners ID Verify Info',
  'ConnectorService.resetCourse_/api/enrollments/reset-course': 'Course Reset',
  'ConnectorService.patchLearnerContactInfo_/api/learner': 'Update Learners Contact Info',
  'ConnectorService.requestNameChange_/api/learner': 'Learners Request Name Change',
  'ConnectorService.refreshAndAddEnrollmentToSFForSelectedCourses_/api/enrollments':
    'Selected Course Enrollment/Unenrollment'
};
